import React from "react";

/**
 * component svg menu button
 */
const SearchSimilarButton = function (props) {

    return (
        <svg id="similar-paper-search-icon" xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 1000 1000">
            <polyline className="st0-sps" points="795.8,214 734.8,214 736.8,146 		"/>
            <polyline className="st0-sps" points="842.8,214 842.8,875.8 262.8,875.8 262.8,106 734.8,106 		"/>
            <line className="st0-sps" x1="842.8" y1="214" x2="734.8" y2="106"/>
            <line className="st1-sps" x1="350.8" y1="198.9" x2="644.8" y2="198.9"/>
            <line className="st2-sps" x1="346.8" y1="385.4" x2="752.8" y2="385.4"/>
            <line className="st2-sps" x1="544" y1="485.9" x2="752.8" y2="485.9"/>
            <line className="st3-sps" x1="346.8" y1="485.9" x2="544" y2="485.9"/>
            <line className="st2-sps" x1="575.9" y1="586.4" x2="752.8" y2="586.4"/>
            <line className="st3-sps" x1="346.8" y1="586.4" x2="575.9" y2="586.4"/>
            <line className="st2-sps" x1="555.5" y1="686.9" x2="752.8" y2="686.9"/>
            <line className="st3-sps" x1="346.8" y1="686.9" x2="555.5" y2="686.9"/>
            <circle className="st4-sps" cx="410.8" cy="594.3" r="171.7"/>
            <line className="st4-sps" x1="111.2" y1="894" x2="289.4" y2="715.7"/>
        </svg>
        
    );
};

export default SearchSimilarButton;
